import {
  Badge,
  Box,
  Button,
  FormControl,
  Image,
  Input,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { Icon, Img } from "../../../../content/Content";
import { FaShare, FaThumbsUp } from "react-icons/fa6";
import "./Annoucement.css";
const AnnouncementsLeft = () => {
  const AnnouncementsData = [
    {
      title: "Erik Wilkes Jr.",
      username: "@wilkesjr",
      badge: Icon.Badge,
      avatar: Img.PostAvatar1,
      photo: "",
      postDetails: "They sure do have a great collection. 💯",
      time: "11:12 PM · Sep 1, 2022",
      like: true,
    },
    {
      title: "Clarissa Kearney.",
      username: "@clarissaboo",
      badge: Icon.Badge,
      avatar: Img.PostAvatar2,
      photo: Img.post,
      postDetails: "They sure do have a great collection. 💯",
      time: "11:12 PM · Sep 1, 2022",
      like: false,
    },
    {
      title: "Erik Wilkes Jr.",
      username: "@wilkesjr",
      badge: Icon.Badge,
      avatar: Img.PostAvatar3,
      photo: "",
      postDetails: "They sure do have a great collection. 💯",
      time: "11:12 PM · Sep 1, 2022",
      like: false,
    },
    {
      title: "Erik Wilkes Jr.",
      username: "@wilkesjr",
      badge: Icon.Badge,
      avatar: Img.PostAvatar4,
      photo: "",
      postDetails: "They sure do have a great collection. 💯",
      time: "11:12 PM · Sep 1, 2022",
      like: false,
    },
    {
      title: "Erik Wilkes Jr.",
      username: "@wilkesjr",
      badge: Icon.Badge,
      avatar: Img.PostAvatar5,
      photo: "",
      postDetails: "They sure do have a great collection. 💯",
      time: "11:12 PM · Sep 1, 2022",
      like: false,
    },
    {
      title: "Erik Wilkes Jr.",
      username: "@wilkesjr",
      badge: Icon.Badge,
      avatar: Img.PostAvatar6,
      photo: "",
      postDetails: "They sure do have a great collection. 💯",
      time: "11:12 PM · Sep 1, 2022",
      like: false,
    },
  ];
  return (
    <VStack>
      <Stack
        w={{ base: "100%", sm: "100%", md: "95%", lg: "90%", xl: "85%" }}
        mx="auto"
        flexDir="row"
        alignItems="center"
      >
        <Box w="60%">
          <Text
            fontFamily="'Roboto',sans-serif"
            fontSize="40px"
            fontWeight="700"
            textAlign="left"
            ml="10px"
          >
            Announcements
          </Text>
        </Box>
        <Box w="40%" display={"flex"} justifyContent="flex-end">
          <Button
            color="#fff"
            bg="#000000"
            borderRadius="6px"
            fontFamily="'Roboto',sans-serif"
            fontSize="14px"
            fontWeight="600"
            textAlign="center"
            _hover={{ backgroundColor: "#000000" }}
            w="35%"
          >
            General
          </Button>
          <Button
            mx="8px"
            color="#fff"
            bg="#0071C1"
            borderRadius="6px"
            fontFamily="'Roboto',sans-serif"
            fontSize="14px"
            fontWeight="600"
            textAlign="center"
            _hover={{ backgroundColor: "#0071C1" }}
            w="65%"
          >
            Team Announcements
          </Button>
        </Box>
      </Stack>
      <Stack
        w={{ base: "100%", sm: "100%", md: "95%", lg: "90%", xl: "85%" }}
        py="25px"
      >
        <Box w="100%" pb="20px">
          <FormControl>
            <Input
              type="text"
              placeholder="Type announcement here"
              w="100%"
              px="25px"
              h="52px"
              borderRadius="8px"
              bg="#FFFFFF"
              fontFamily="'Roboto',sans-serif"
              fontSize="16px"
              fontWeight="400"
              color="#9597AB"
              _placeholder={{
                fontFamily: "'Roboto',sans-serif",
                fontSize: "16px",
                fontWeight: "400",
                color: "#9597AB",
              }}
            />
          </FormControl>
        </Box>
      </Stack>
      <Stack w="100%" py="25px">
        <Stack pe="20px" height="620px" overflowY="auto" className="announcements-scroll">
          {AnnouncementsData.map((item) => (
            <Stack
              w={{ base: "100%", sm: "100%", md: "95%", lg: "90%", xl: "85%" }}
              mx="auto"
            >
              <Box
                w="100%"
                bg="#FFFFFF"
                borderRadius="26px"
                p="20px 30px"
                my="20px"
              >
                {/* topbar */}
                <Stack flexWrap="wrap" alignItems="center" w="100%">
                  <Stack
                    flexDir="row"
                    justifyContent="space-between"
                    alignItems="center"
                    w="100%"
                  >
                    <Box display="flex" alignItems="center" w="80%">
                      <Image src={item.avatar} h="43px" w="43px" mr="10px" />
                      <Box>
                        <Text
                          fontFamily="'Roboto',sans-serif"
                          fontSize="20px"
                          fontWeight="600"
                        >
                          {item.title}
                          <Badge variant="subtle">
                            {" "}
                            <Image src={item.badge} />
                          </Badge>
                        </Text>
                        <Text
                          fontFamily="'Roboto',sans-serif"
                          fontSize="16px"
                          fontWeight="400"
                        >
                          {item.username}
                        </Text>
                      </Box>
                    </Box>
                    <Box
                      display="flex"
                      alignItems="center"
                      w="20%"
                      justifyContent="flex-end"
                    >
                      <Image src={Icon.Share} w="17.16px" h="14.43px" />
                      <Text
                        color="#00000099"
                        px="5px"
                        fontFamily="'Roboto',sans-serif"
                        fontSize="16px"
                        fontWeight="400"
                      >
                        Share
                      </Text>
                    </Box>
                  </Stack>
                  <Stack flexDir="row" alignItems="center" w="100%">
                    <Box w="80%">
                      {item.photo ? (
                        <Image src={item.photo} h="245px" w="525px" my="10px" />
                      ) : (
                        ""
                      )}
                      <Text
                        fontFamily="'Roboto',sans-serif"
                        fontSize="16px"
                        fontWeight="400"
                      >
                        {item.postDetails}
                      </Text>
                      <Text
                        fontFamily="'Roboto',sans-serif"
                        fontSize="16px"
                        fontWeight="400"
                      >
                        {item.time}
                      </Text>

                      <Button
                        px="0"
                        display="flex"
                        alignItems="center"
                        bg={"transparent"}
                        _hover={{
                          bg: "transparent",
                        }}
                        color={item.like ? "#129BF7" : "#9597AB"}
                      >
                        <FaThumbsUp />
                        <Text
                          mx="5px"
                          fontFamily="'Roboto',sans-serif"
                          fontSize="16px"
                          fontWeight="400"
                        >
                          Like
                        </Text>
                      </Button>
                    </Box>
                  </Stack>
                </Stack>
              </Box>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </VStack>
  );
};

export default AnnouncementsLeft;
